import React, { Component } from "react";
import Spinner from "../../LayOut/Spinner";
import { Button } from "devextreme-react";
import DateBox from "devextreme-react/date-box";
import SelectBox from "devextreme-react/select-box";
import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  Export,
  Scrolling,
} from "devextreme-react/data-grid";
import { loadMessages, locale } from "devextreme/localization";
import { getComteleSmsReport } from "../../../apis/toowezeApi";
import { i18n, lgMessages, languageCode } from "../../../translate/i18n";
import "./ComteleSmsReportMiddle.css";

const DELIVERED_OPTIONS = [
  { value: "all", textKey: "reports.comtelesms.deliveredAll" },
  { value: "true", textKey: "reports.comtelesms.deliveredTrue" },
  { value: "false", textKey: "reports.comtelesms.deliveredFalse" },
];

const TYPE_OPTIONS = [
  { value: "all", textKey: "reports.comtelesms.typeAll" },
  { value: "token", textKey: "reports.comtelesms.typeToken" },
  { value: "other", textKey: "reports.comtelesms.typeOther" },
];

function classifySmsIssue(row) {
  const msg = String(row.systemMessage || "").toLowerCase();
  const dlr = String(row.dlrStatus || "").toLowerCase();
  const status = String(row.status || "").toLowerCase();

  if (status === "delivered" || dlr === "delivered") {
    return null;
  }

  const invalidPhone =
    /n[uú]mero informado n[aã]o [eé] v[aá]lido/.test(msg) ||
    /n[aã]o foi encontrado em nenhuma operadora/.test(msg) ||
    /n[uú]mero inexistente/.test(msg) ||
    /padr[oõ]es de n[uú]meros v[aá]lidos/.test(msg) ||
    /telefone desativado/.test(msg) ||
    /telefone incorreto/.test(msg) ||
    /destinat[aá]rio.*(em branco|vazio)/.test(msg) ||
    /celular inv[aá]lido/.test(msg) ||
    /n[uú]mero.*inv[aá]lido/.test(msg);

  if (invalidPhone) {
    return "invalid_phone";
  }

  const operatorError =
    /operadora/.test(msg) ||
    /n[aã]o foi aceita/.test(msg) ||
    /rejeitada pela/.test(msg) ||
    /recusada pela/.test(msg) ||
    /recusa t[eé]cnica/.test(msg) ||
    /indisponibilidade/.test(msg) ||
    /n[aã]o foi entregue ao destinat[aá]rio final/.test(msg) ||
    /excedeu o limite de tentativas/.test(msg) ||
    /esgotamos as tentativas/.test(msg) ||
    dlr === "undelivered" ||
    dlr === "expired" ||
    status === "error";

  if (operatorError) {
    return "operator_error";
  }

  return null;
}

function classifyMessageType(content) {
  const text = String(content || "").toLowerCase();
  // Textos OTP TooWeze: "Código de verificação de cadastro..." / "...uso de Cashback..."
  if (
    /c[oó]digo de verifica[cç][aã]o/.test(text) ||
    /\botp\b/.test(text) ||
    /token/.test(text)
  ) {
    return "token";
  }
  return "other";
}

/** Remove 55; formata (DD) 9XXXX-XXXX */
function formatBrazilPhone(raw) {
  if (!raw) {
    return "";
  }
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("55") && digits.length >= 12) {
    digits = digits.slice(2);
  }
  // Remove 0 trunk residual (ex.: 0819...)
  if (digits.startsWith("0") && digits.length >= 11) {
    digits = digits.slice(1);
  }
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return digits || String(raw);
}

export default class ComteleSmsReportMiddle extends Component {
  constructor(props) {
    super(props);
    const monthDates = this.getMonthDates();
    this.state = {
      allRows: [],
      datagrid: [],
      spinner: false,
      error: null,
      info: null,
      customStartDate: monthDates.startOfMonth,
      customEndDate: monthDates.endOfMonth,
      delivered: "all",
      messageType: "all",
      total: 0,
      tokenCount: 0,
      otherCount: 0,
      sendLogRows: [],
      sendLogErrorCount: 0,
      sendLogSuccessCount: 0,
      cooldownUntil: 0,
    };
    this._requestSeq = 0;
    loadMessages(lgMessages);
    locale(languageCode);
  }

  componentWillUnmount() {
    this._requestSeq += 1;
    if (this._cooldownTimer) {
      clearInterval(this._cooldownTimer);
    }
  }

  returnDateValue(newDate) {
    return (
      newDate.getFullYear() +
      "-" +
      ("0" + (newDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + newDate.getDate()).slice(-2)
    );
  }

  getMonthDates() {
    const date = new Date();
    const initDate = new Date(date.getFullYear(), date.getMonth(), 1);
    const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return {
      startOfMonth: this.returnDateValue(initDate) + "T00:00:00.00-03:00",
      endOfMonth: this.returnDateValue(endDate) + "T23:59:59.00-03:00",
    };
  }

  handleValueChange(event, type) {
    if (!event.value) {
      return;
    }
    const day = this.returnDateValue(new Date(event.value.toString()));
    if (type === "customStartDate") {
      this.setState({ customStartDate: day + "T00:00:00.00-03:00" });
    } else if (type === "customEndDate") {
      this.setState({ customEndDate: day + "T23:59:59.00-03:00" });
    }
  }

  startCooldown(seconds) {
    const cooldownUntil = Date.now() + seconds * 1000;
    this.setState({ cooldownUntil });
    if (this._cooldownTimer) {
      clearInterval(this._cooldownTimer);
    }
    this._cooldownTimer = setInterval(() => {
      if (Date.now() >= this.state.cooldownUntil) {
        clearInterval(this._cooldownTimer);
        this._cooldownTimer = null;
        this.setState({ cooldownUntil: 0 });
      } else {
        this.forceUpdate();
      }
    }, 1000);
  }

  cooldownRemainingSeconds() {
    if (!this.state.cooldownUntil) {
      return 0;
    }
    return Math.max(0, Math.ceil((this.state.cooldownUntil - Date.now()) / 1000));
  }

  applyLocalFilters = (allRows, messageType) => {
    const tokenCount = allRows.filter((r) => r.messageType === "token").length;
    const otherCount = allRows.length - tokenCount;
    let datagrid = allRows;
    if (messageType === "token") {
      datagrid = allRows.filter((r) => r.messageType === "token");
    } else if (messageType === "other") {
      datagrid = allRows.filter((r) => r.messageType !== "token");
    }
    return { datagrid, tokenCount, otherCount };
  };

  onMessageTypeChange = (value) => {
    const filtered = this.applyLocalFilters(this.state.allRows, value);
    this.setState({
      messageType: value,
      ...filtered,
      info:
        filtered.datagrid.length === 0 && this.state.allRows.length > 0
          ? i18n.t("reports.comtelesms.emptyType")
          : null,
    });
  };

  fetchReport = () => {
    const { customStartDate, customEndDate, delivered, messageType } = this.state;
    const remaining = this.cooldownRemainingSeconds();

    if (remaining > 0) {
      this.setState({
        error: i18n.t("reports.comtelesms.cooldownWait", { seconds: remaining }),
      });
      return;
    }

    if (!customStartDate || !customEndDate) {
      this.setState({
        error: i18n.t("reports.comtelesms.datesRequired"),
      });
      return;
    }

    const requestSeq = ++this._requestSeq;
    this.setState({
      spinner: true,
      error: null,
      info: null,
    });

    getComteleSmsReport(customStartDate, customEndDate, delivered)
      .then((result) => {
        if (requestSeq !== this._requestSeq) {
          return;
        }
        this.startCooldown(30);
        const allRows = (result.rows || []).map((row) => ({
          ...row,
          receiverFormatted: formatBrazilPhone(row.receiver),
          issueTag: classifySmsIssue(row),
          messageType: classifyMessageType(row.content),
        }));
        const filtered = this.applyLocalFilters(allRows, messageType);
        const sendLogs = result.sendLogs || {};
        const sendLogRows = (sendLogs.rows || []).map((row) => ({
          ...row,
          receiverFormatted: formatBrazilPhone(row.receiver),
        }));
        this.setState({
          allRows,
          total: allRows.length,
          spinner: false,
          ...filtered,
          sendLogRows,
          sendLogErrorCount: sendLogs.errorCount || 0,
          sendLogSuccessCount: sendLogs.successCount || 0,
          info:
            allRows.length === 0 && sendLogRows.length === 0
              ? i18n.t("reports.comtelesms.empty")
              : filtered.datagrid.length === 0 && allRows.length > 0
                ? i18n.t("reports.comtelesms.emptyType")
                : null,
        });
      })
      .catch((error) => {
        if (requestSeq !== this._requestSeq) {
          return;
        }
        const retryAfter =
          error?.response?.data?.retryAfterSeconds ||
          (error?.response?.status === 429 ? 30 : 0);
        if (retryAfter) {
          this.startCooldown(retryAfter);
        }
        const message =
          error?.response?.data?.msg ||
          error?.message ||
          i18n.t("reports.comtelesms.loadError");
        this.setState({
          allRows: [],
          datagrid: [],
          total: 0,
          tokenCount: 0,
          otherCount: 0,
          sendLogRows: [],
          sendLogErrorCount: 0,
          sendLogSuccessCount: 0,
          spinner: false,
          error: message,
        });
      });
  };

  renderStatusBadge = (cell) => {
    const status = (cell.value || "").toString().toLowerCase();
    let badge = "badge-secondary";
    if (status === "delivered") {
      badge = "badge-success";
    } else if (status === "error" || status === "undelivered" || status === "rejected") {
      badge = "badge-danger";
    } else if (status === "processed" || status === "accepted" || status === "expired") {
      badge = "badge-warning";
    }
    return (
      <span className={`badge ${badge} comtele-sms-badge`}>
        {cell.value || "—"}
      </span>
    );
  };

  renderDate = (cell) => {
    if (!cell.value) {
      return "—";
    }
    try {
      const d = new Date(cell.value);
      if (Number.isNaN(d.getTime())) {
        return cell.value;
      }
      return d.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "America/Sao_Paulo",
      });
    } catch (e) {
      return cell.value;
    }
  };

  renderPhone = (cell) => (
    <span className="comtele-sms-phone">
      {cell.data?.receiverFormatted || formatBrazilPhone(cell.value) || "—"}
    </span>
  );

  renderIssueTag = (cell) => {
    const tag = cell.value || cell.data?.issueTag;
    if (tag === "invalid_phone") {
      return (
        <span className="badge badge-danger comtele-sms-badge">
          {i18n.t("reports.comtelesms.tagInvalidPhone")}
        </span>
      );
    }
    if (tag === "operator_error") {
      return (
        <span className="badge badge-warning comtele-sms-badge">
          {i18n.t("reports.comtelesms.tagOperatorError")}
        </span>
      );
    }
    if (cell.data?.messageType === "token") {
      return (
        <span className="badge badge-info comtele-sms-badge">
          {i18n.t("reports.comtelesms.tagToken")}
        </span>
      );
    }
    return <span className="text-muted">—</span>;
  };

  renderSystemMessage = (cell) => (
    <div className="comtele-sms-msg" title={cell.value || undefined}>
      {cell.value || "—"}
    </div>
  );

  renderContent = (cell) => (
    <div className="comtele-sms-content" title={cell.value || undefined}>
      {cell.value || "—"}
    </div>
  );

  renderSendSuccess = (cell) => {
    if (cell.value === true) {
      return (
        <span className="badge badge-success comtele-sms-badge">
          {i18n.t("reports.comtelesms.sendOk")}
        </span>
      );
    }
    return (
      <span className="badge badge-danger comtele-sms-badge">
        {i18n.t("reports.comtelesms.sendFail")}
      </span>
    );
  };

  renderPurpose = (cell) => {
    const map = {
      otp_transaction: i18n.t("reports.comtelesms.purposeOtpTxn"),
      otp_signup: i18n.t("reports.comtelesms.purposeOtpSignup"),
      otp: i18n.t("reports.comtelesms.tagToken"),
      transactional: i18n.t("reports.comtelesms.purposeTransactional"),
      other: i18n.t("reports.comtelesms.typeOther"),
    };
    return map[cell.value] || cell.value || "—";
  };

  mapOptions(list) {
    return list.map((opt) => ({
      value: opt.value,
      text: i18n.t(opt.textKey),
    }));
  }

  render() {
    const {
      spinner,
      error,
      info,
      datagrid,
      total,
      tokenCount,
      otherCount,
      customStartDate,
      customEndDate,
      delivered,
      messageType,
      sendLogRows,
      sendLogErrorCount,
      sendLogSuccessCount,
    } = this.state;
    const cooldownSeconds = this.cooldownRemainingSeconds();
    const canSearch = !spinner && cooldownSeconds === 0;
    const sendLogErrors = sendLogRows.filter((r) => r.success === false);
    const hasFetched = !spinner && !error && (total > 0 || sendLogRows.length > 0 || info);

    return (
      <div className="comtele-sms-report">
        <h1>{i18n.t("reports.comtelesms.title")}</h1>
        <p className="comtele-sms-report__hint">
          {i18n.t("reports.comtelesms.subtitle")}
        </p>

        <div className="comtele-sms-report__toolbar">
          <div className="comtele-sms-report__field">
            <label>{i18n.t("transactions.activity.startDate")}</label>
            <DateBox
              type="date"
              value={customStartDate || null}
              onValueChanged={(event) =>
                this.handleValueChange(event, "customStartDate")
              }
              width="100%"
            />
          </div>
          <div className="comtele-sms-report__field">
            <label>{i18n.t("transactions.activity.endDate")}</label>
            <DateBox
              type="date"
              value={customEndDate || null}
              onValueChanged={(event) =>
                this.handleValueChange(event, "customEndDate")
              }
              width="100%"
            />
          </div>
          <div className="comtele-sms-report__field">
            <label>{i18n.t("reports.comtelesms.deliveredLabel")}</label>
            <SelectBox
              items={this.mapOptions(DELIVERED_OPTIONS)}
              value={delivered}
              displayExpr="text"
              valueExpr="value"
              onValueChanged={(e) => this.setState({ delivered: e.value })}
              width="100%"
            />
          </div>
          <div className="comtele-sms-report__field">
            <label>{i18n.t("reports.comtelesms.typeLabel")}</label>
            <SelectBox
              items={this.mapOptions(TYPE_OPTIONS)}
              value={messageType}
              displayExpr="text"
              valueExpr="value"
              onValueChanged={(e) => this.onMessageTypeChange(e.value)}
              width="100%"
            />
          </div>
          <div className="comtele-sms-report__field comtele-sms-report__field--btn">
            <label>&nbsp;</label>
            <Button
              text={
                cooldownSeconds > 0
                  ? i18n.t("reports.comtelesms.searchCooldown", {
                      seconds: cooldownSeconds,
                    })
                  : i18n.t("reports.comtelesms.search")
              }
              type="default"
              stylingMode="contained"
              disabled={!canSearch}
              onClick={this.fetchReport}
              width="100%"
              height={36}
            />
          </div>
        </div>

        <div className="alert alert-warning comtele-sms-alert" role="alert">
          {i18n.t("reports.comtelesms.cooldownNotice")}
        </div>

        {spinner && <Spinner />}

        {!spinner && error && (
          <div className="alert alert-danger comtele-sms-alert" role="alert">
            {error}
          </div>
        )}

        {!spinner && !error && info && (
          <div className="alert alert-info comtele-sms-alert" role="alert">
            {info}
          </div>
        )}

        {hasFetched && sendLogErrorCount > 0 && (
          <div className="alert alert-danger comtele-sms-alert" role="alert">
            {i18n.t("reports.comtelesms.sendErrorsAlert", {
              count: sendLogErrorCount,
            })}
          </div>
        )}

        {hasFetched && (
          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: "1.1rem", marginBottom: 8 }}>
              {i18n.t("reports.comtelesms.sendLogsTitle")}
            </h2>
            <p className="comtele-sms-report__hint">
              {i18n.t("reports.comtelesms.sendLogsHint")}
            </p>
            <div className="comtele-sms-report__meta">
              <span className="comtele-sms-report__chip comtele-sms-report__chip--warn">
                {i18n.t("reports.comtelesms.sendFail")}:{" "}
                <strong>{sendLogErrorCount}</strong>
              </span>
              <span className="comtele-sms-report__chip">
                {i18n.t("reports.comtelesms.sendOk")}:{" "}
                <strong>{sendLogSuccessCount}</strong>
              </span>
            </div>
            <div className="comtele-sms-report__grid">
              <DataGrid
                dataSource={sendLogErrors.length ? sendLogErrors : sendLogRows}
                keyExpr="id"
                showBorders={false}
                showRowLines={true}
                rowAlternationEnabled={true}
                wordWrapEnabled={true}
                height={Math.min(360, 80 + Math.max(sendLogErrors.length, sendLogRows.length, 1) * 40)}
                hoverStateEnabled={true}
                noDataText={i18n.t("reports.comtelesms.sendLogsEmpty")}
              >
                <Scrolling mode="standard" useNative={true} showScrollbar="always" />
                <Paging defaultPageSize={10} />
                <Pager showInfo={true} />
                <SearchPanel visible={true} width={220} />
                <Column
                  dataField="createdAt"
                  caption={i18n.t("reports.comtelesms.colRequestDate")}
                  width={120}
                  cellRender={this.renderDate}
                  sortOrder="desc"
                />
                <Column
                  dataField="receiverFormatted"
                  caption={i18n.t("reports.comtelesms.colReceiver")}
                  width={140}
                  cellRender={this.renderPhone}
                />
                <Column
                  dataField="purpose"
                  caption={i18n.t("reports.comtelesms.colPurpose")}
                  width={140}
                  cellRender={this.renderPurpose}
                />
                <Column
                  dataField="success"
                  caption={i18n.t("reports.comtelesms.colSendStatus")}
                  width={100}
                  cellRender={this.renderSendSuccess}
                />
                <Column
                  dataField="errorMessage"
                  caption={i18n.t("reports.comtelesms.colError")}
                  width={320}
                  cellRender={this.renderSystemMessage}
                />
                <Column
                  dataField="content"
                  caption={i18n.t("reports.comtelesms.colContent")}
                  width={260}
                  cellRender={this.renderContent}
                />
                <Column dataField="errorCode" caption="Code" width={110} />
                <Export enabled={true} fileName="TooWeze_SMS_SendLogs" />
              </DataGrid>
            </div>
          </section>
        )}

        {!spinner && !error && total > 0 && (
          <>
            <h2 style={{ fontSize: "1.1rem", marginBottom: 8 }}>
              {i18n.t("reports.comtelesms.comteleTitle")}
            </h2>
            <div className="comtele-sms-report__meta">
              <span>
                {i18n.t("reports.comtelesms.totalLabel")}: <strong>{total}</strong>
              </span>
              <span className="comtele-sms-report__chip">
                {i18n.t("reports.comtelesms.tokenCount")}: <strong>{tokenCount}</strong>
              </span>
              <span className="comtele-sms-report__chip comtele-sms-report__chip--warn">
                {i18n.t("reports.comtelesms.otherCount")}: <strong>{otherCount}</strong>
              </span>
              {messageType !== "all" && (
                <span>
                  {i18n.t("reports.comtelesms.showing")}: <strong>{datagrid.length}</strong>
                </span>
              )}
            </div>

            <div className="comtele-sms-report__grid">
              <DataGrid
                dataSource={datagrid}
                keyExpr={null}
                showBorders={false}
                showRowLines={true}
                showColumnLines={false}
                rowAlternationEnabled={true}
                wordWrapEnabled={true}
                columnAutoWidth={false}
                height={520}
                hoverStateEnabled={true}
                noDataText={i18n.t("reports.comtelesms.emptyType")}
              >
                <Scrolling mode="standard" useNative={true} showScrollbar="always" />
                <Paging defaultPageSize={20} />
                <Pager
                  showInfo={true}
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                />
                <SearchPanel
                  visible={true}
                  width={260}
                  placeholder={i18n.t("reports.comtelesms.searchPlaceholder")}
                />

                <Column
                  dataField="requestDate"
                  caption={i18n.t("reports.comtelesms.colRequestDate")}
                  width={115}
                  cellRender={this.renderDate}
                  sortOrder="desc"
                />
                <Column
                  dataField="receiverFormatted"
                  caption={i18n.t("reports.comtelesms.colReceiver")}
                  width={140}
                  cellRender={this.renderPhone}
                />
                <Column
                  dataField="dlrStatus"
                  caption={i18n.t("reports.comtelesms.colStatus")}
                  width={110}
                  cellRender={this.renderStatusBadge}
                />
                <Column
                  dataField="issueTag"
                  caption={i18n.t("reports.comtelesms.colIssueTag")}
                  width={125}
                  cellRender={this.renderIssueTag}
                />
                <Column
                  dataField="systemMessage"
                  caption={i18n.t("reports.comtelesms.colError")}
                  width={300}
                  cellRender={this.renderSystemMessage}
                />
                <Column
                  dataField="content"
                  caption={i18n.t("reports.comtelesms.colContent")}
                  width={280}
                  cellRender={this.renderContent}
                />
                <Column
                  dataField="credits"
                  caption={i18n.t("reports.comtelesms.colCredits")}
                  width={65}
                  alignment="center"
                />

                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="TooWeze_SMS_Comtele"
                />
              </DataGrid>
            </div>
          </>
        )}
      </div>
    );
  }
}
